<h1 mat-dialog-title>{{ data?.title }}</h1>
<div mat-dialog-content>
  <p [innerHtml]="data.body"></p>
</div>
